export function getStreamDayTimeStart(streamStart, streamDay) {
    let date = new Date((streamStart + streamDay*3600*24) * 1000);
    date.setUTCHours(0);
    date.setUTCMinutes(0);
    date.setUTCSeconds(0);
    date.setUTCMilliseconds(0);

    return Math.round(date.getTime() / 1000);
}

export const getStreamDayRange = (streamStart, streamDay)  => {
    if (!Number.isFinite(streamStart) || !Number.isFinite(streamDay)) return [0, 0];

    const start = getStreamDayTimeStart(streamStart, streamDay);
    const end = start + (3600 * 24);

    return [start, end];
}

export const getStreamDayRangeBySessions = (stream, streamDay, cutDay = false) => {
    const [dateStart, dateStop] = getStreamDayRange(stream.timeStart, streamDay);
    const daySessions = stream.broadcastSession
        .filter((session) => session.timeStart < dateStop && (session.timeStop > dateStart || !session.timeStop))
        .sort((a, b) => a.timeStart - b.timeStart)
    ;
    if (0 === daySessions.length) {
        return [null, null, 0];
    }
    if (cutDay) {
        daySessions.forEach((session) => {
            if (session.timeStart < dateStart) {
                session.timeStart = dateStart;
            }
            if (session.timeStop > dateStop) {
                session.timeStop = dateStop;
            }
        });
    }

    const start = daySessions[0].timeStart;
    const stop = daySessions[daySessions.length - 1].timeStop;
    const duration = daySessions.reduce((duration, {timeStart, timeStop}) => {
        return duration + (timeStop ?? Math.round(Date.now() / 1000)) - timeStart;
    }, 0);

    return [start, stop, duration];
}


export const getPlayerTimeByAbsoluteTime = (absoluteTime, broadcastSessions, day, streamTimeStart) => {
    const [dayStart, dayEnd] = getStreamDayRange(streamTimeStart, day);

    return broadcastSessions.length ?
            broadcastSessions
                .filter(session => dayStart && dayEnd ? session.timeStart >= dayStart && (!session.timeStop || session.timeStop <= dayEnd) : true)
                .sort((a, b) => a.timeStart - b.timeStart)
                .reduce((playerTime, {timeStart, timeStop}) => {
                    if (timeStart > absoluteTime) {
                        return playerTime;
                    }
                    if (!timeStop) {
                        timeStop = (Math.round(Date.now() / 1000) + 3600*24);
                    }
                    if (timeStop < absoluteTime) {
                        return playerTime + timeStop - timeStart;
                    }

                    return playerTime + absoluteTime - timeStart;
                }, 0) :
                absoluteTime - streamTimeStart;
};

export function getAbsoluteTimeByPlayerTime(playerTime, day, broadcastSessions, streamTimeStart, streamTimeStop) {
    const [dayStart, dayEnd] = getStreamDayRange(streamTimeStart, day);
    const streamDayTimeStart = getStreamDayTimeStart(streamTimeStart, day || 0);
    streamTimeStop = (day ? streamTimeStart : getStreamDayTimeStart(streamTimeStop, 0)) + 3600 * 24;

    if (broadcastSessions.length) {
        const sessions = broadcastSessions.filter(session => dayStart && dayEnd ? session.timeStart >= dayStart && (!session.timeStop || session.timeStop <= dayEnd) : true);

        for(let i = 0; i < sessions.length; i++) {
            const session = sessions[i];
            if (session.timeStart > streamTimeStop || (session.timeStop && session.timeStop < streamDayTimeStart)) {
                continue;
            }

            if(session.timeStop) {
                if(session.timeStop - session.timeStart > playerTime) {
                    return session.timeStart + playerTime;
                } else {
                    playerTime -= session.timeStop - session.timeStart;
                }
            } else {
                return session.timeStart + playerTime;
            }
        }
    } else {
        return playerTime + streamTimeStart
    }

    return null;
}
